import { dispatchGlobalEvent } from "@storytell/events";
import type { LabelId } from "@storytell/types";
import { Show } from "solid-js";
import { useWire } from "~/wire";

export const LabelTooltip = (props: { labelId: string }) => {
  const wire = useWire();

  const label = () => wire.labels.get(props.labelId as LabelId);

  const labelAssets = () => wire.rels.assetsForLabel(props.labelId as LabelId);

  return (
    <div class="flex flex-col gap-1">
      <h4 class="text-xs font-medium">{label()?.name}</h4>
      <Show when={label()?.description}>
        <p class="text-xs text-secondary-text max-w-xs line-clamp-2">{label()?.description}</p>
      </Show>

      <button
        type="button"
        class="text-xs text-brand underline cursor-pointer"
        onClick={() => {
          dispatchGlobalEvent("open-label-in-assets-pane", { labelId: props.labelId });
        }}
      >
        {labelAssets().length} asset{labelAssets().length === 1 ? "" : "s"} associated with this label
      </button>
    </div>
  );
};
